import defaultValue from "./paceLabsLSPMSlice";

export default defaultValue;
export * from "./paceLabsLSPMSlice";
